import React from "react";
import { connect } from "react-redux";
import "./_PriceDisplay.scss";
import { ReactComponent as EyeIcon } from "../../assets/svg/eye-icon.svg";
import { ReactComponent as EyeIconClosed } from "../../assets/svg/eye-closed-icon.svg";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class PriceDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priceHidden: false,
    };
  }

  renderPrice = (mainRing, holderRings) => {
    if (this.state.priceHidden) {
      return <span className="price-text transparent">0000 €</span>;
    }
    const mainRingMaterial = this.getCurrentMaterial();
    const holderRingMaterial = this.getCurrentMaterial(false);
    let mainRingPrice = 0;
    let holderRingPrice = 0;
    if (mainRing) {
      switch (mainRingMaterial) {
        case "yellow-gold":
          mainRingPrice = mainRing.fields.priceYellowGold;
          break;
        case "rose-gold":
          mainRingPrice = mainRing.fields.priceRoseGold;
          break;
        case "white-gold":
          mainRingPrice = mainRing.fields.priceWhiteGold;
          break;
        case "platinum":
          mainRingPrice = mainRing.fields.pricePlatinum;
          break;
        default:
          break;
      }
    }
    if (holderRings) {
      switch (holderRingMaterial) {
        case "yellow-gold":
          holderRingPrice = holderRings.fields.priceYellowGold;
          break;
        case "rose-gold":
          holderRingPrice = holderRings.fields.priceRoseGold;
          break;
        case "white-gold":
          holderRingPrice = holderRings.fields.priceWhiteGold;
          break;
        case "platinum":
          holderRingPrice = holderRings.fields.pricePlatinum;
          break;
        default:
          break;
      }
    }
    let priceTotal = mainRingPrice + holderRingPrice * 2;
    if (mainRing && mainRing.fields.diamondSize > 0.5) {
      priceTotal = 0;
    }
    if (priceTotal === 0) {
      return <span className="price-text text-format">Ota yhteyttä</span>;
    }
    return <span className="price-text">{priceTotal} €</span>;
  };

  getCurrentMaterial = (mainRing = true) => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams) {
      if (mainRing) {
        return queryParams["ring-material"];
      } else {
        return queryParams["holder-material"];
      }
    }
  };

  onPress = () => {
    this.setState((prevState) => ({
      priceHidden: !prevState.priceHidden,
    }));
  };

  renderPriceTogglebutton = () => {
    if (this.state.priceHidden) {
      return (
        <EyeIconClosed
          className="price-toggle-button"
          onClick={() => this.onPress()}
        />
      );
    } else {
      return (
        <EyeIcon
          className="price-toggle-button"
          onClick={() => this.onPress()}
        />
      );
    }
  };

  render() {
    const { activeMainRing, activeHolderRings, title } = this.props;
    return (
      <div className="price-display">
        <span className="component-title">
          {title}
          {this.renderPriceTogglebutton()}
        </span>
        {this.renderPrice(activeMainRing, activeHolderRings)}
      </div>
    );
  }
}

const mapStateToProps = ({ ring }) => {
  const { activeMainRing, activeHolderRings } = ring;

  return {
    activeMainRing,
    activeHolderRings,
  };
};

export default connect(mapStateToProps, {})(withRouter(PriceDisplay));
